import { Flex, Text } from "@radix-ui/themes";

import { Callout } from "../../common/components";
import { Spinner } from "../../common/components/Spinner";
import { useSampleRequestContext } from "../../state/SampleRequestContext";
import { NeedsVerifiedUser } from "../components/NeedsVerification";
import { SampleRequestForm } from "../components/SampleRequestForm";

export const SampleRequestsCart = () => {
  const { pendingSampleRequest, pendingSampleRequestLoading } =
    useSampleRequestContext();

  return (
    <NeedsVerifiedUser>
      <Flex direction="column" gap="4" px="4">
        {!pendingSampleRequest ? (
          pendingSampleRequestLoading ? (
            <Flex justify="center">
              <Spinner size="lg" />
            </Flex>
          ) : (
            <Callout color="gray">
              <Text size="2" color="gray">
                Your cart is empty. Raw Materials you request samples for will
                appear here.
              </Text>
            </Callout>
          )
        ) : (
          <SampleRequestForm pendingSampleRequest={pendingSampleRequest} />
        )}
      </Flex>
    </NeedsVerifiedUser>
  );
};
